"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var reportbuild_1 = tslib_1.__importDefault(require("./reportbuild"));
var reportrender_1 = tslib_1.__importDefault(require("./reportrender"));
var ReportParamResource = /** @class */ (function (_super) {
    tslib_1.__extends(ReportParamResource, _super);
    function ReportParamResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportParamResource.prototype.getLatestBuild = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sortFn, renderIds, sortedIds, latestId;
            return tslib_1.__generator(this, function (_a) {
                if (!this.id) {
                    throw new Error('ReportParamResource must be saved before running getBuilds()');
                }
                sortFn = function (left, right) { return Number(left) - Number(right); };
                renderIds = this.attributes.renders || [];
                sortedIds = renderIds.concat(renderIds).sort(sortFn);
                latestId = sortedIds[0];
                return [2 /*return*/, reportrender_1.default.detail(latestId)];
            });
        });
    };
    ReportParamResource.endpoint = '/reports/params';
    ReportParamResource.MODEL_NAME = 'reportcachedparameters';
    ReportParamResource.related = {
        builds: reportbuild_1.default,
        renders: reportrender_1.default,
    };
    return ReportParamResource;
}(base_1.default));
exports.default = ReportParamResource;
//# sourceMappingURL=reportparam.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/reports/reportparam.js
// module id = 7NOE
// module chunks = 0